<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
    import {
        connect as connectMqtt
    } from "./mqtt/index";
    import {
        connect as alarmConnect,
        subscribe
    } from "./mqtt/alarm";

    export default {
        name: "App",
        beforeCreate() {
            //在页面加载时读取sessionStorage里的状态信息
            if (sessionStorage.getItem("storeweb")) {
                this.$store.replaceState(
                    Object.assign({},
                        this.$store.state,
                        JSON.parse(sessionStorage.getItem("storeweb"))
                    )
                );
            }
        },
        created() {
            //在页面刷新时将vuex里的信息保存到sessionStorage里
            window.addEventListener("beforeunload", () => {
                sessionStorage.setItem("storeweb", JSON.stringify(this.$store.state));
            });
        },
        mounted() {
            let html = document.getElementsByTagName("html")[0];
            this.reset(html);
            window.onresize = () => {
            
                this.reset(html);
            };
            alarmConnect();
            connectMqtt();
        },
        methods: {
            reset(html) {
                if (window.innerWidth * window.innerHeight <= 1920 * 1080) {
                    html.style.fontSize =
                        (window.innerWidth * window.innerHeight) / 1920 / 1080 + "px";
                    //html.style.fontSize = window.innerWidth / 1920 + 'px'
                } else {
                    html.style.fontSize =
                        (window.innerWidth * window.innerHeight) / 1920 / 1080 / 2 + "px";
                    //html.style.fontSize = window.innerWidth / 1920 + 'px'
                }
            }, 
        },
    };
</script>
<style lang="less">
    @import "assets/css/global";
    @import "assets/css/func";
    @import "./assets/fonts/font.css";
</style>